'use client';

import { use } from 'react';

import RadioGroupContext, { RadioGroupContextValue } from './RadioGroupContext';

export type RadioGroupState = RadioGroupContextValue;

export default function useRadioGroup(): RadioGroupState | undefined {
   return use(RadioGroupContext);
}
